import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from '@parkify/ui/error-boundary'
import App from './App'
import '@parkify/brand-tokens/tokens.css'
import './styles.css'

// Root error boundary (parity with parkify-demo#91): a render error anywhere
// below shows a fallback card with a reload action instead of unmounting the
// whole tree and leaving a blank page.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary label="enforcement-portal">
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
